#import "./ContentBlocksText.graphql"
#import "./ContentBlocksTable.graphql"
#import "./ContentBlocksVideo.graphql"
#import "./ContentBlocksImages.graphql"
#import "./ContentBlocksQuote.graphql"
#import "./ContentBlocksAccordion.graphql"
#import "./ContentBlocksCallToAction.graphql"
#import "./ContentBlocksContentOverview.graphql"
#import "./ContentBlocksSummaryCards.graphql"
#import "#layers/jotform/graphql/fragments/ContentBlocksForm.graphql"
#import "./ContentBlocksCardSlider.graphql"

fragment ContentBlocks on contentBlocks_NeoField {
    __typename
    ... ContentBlockText
    ... ContentBlockTable
    ... ContentBlockQuote
    ... ContentBlockAccordion
    ... ContentBlockForm
    ... ContentBlockCallToAction
    ... ContentBlockContentOverview
    ... ContentBlockSummaryCards
    ... ContentBlocksCardSlider

    ... ContentBlockImages
    ... ContentBlockVideo
}
